import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: true,
  fetchableRange: undefined,
  limit: 100,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
